import { BiomassBurningCellDisplay } from '../CellDisplays'
import { DetailSimpleCellProps } from '../types'

export const BiomassBurningSimpleCell = ({ detail }: DetailSimpleCellProps) => (
  <BiomassBurningCellDisplay value={detail} />
)
